module.exports = __webpack_public_path__ + "static/media/JacobEarth.e6704273.md";